<template>
  <div class="container">
    <header>
      <video ref="video" class="video desktop" muted playsinline loop>
        <source src="../assets/rank.mp4" type="video/mp4" />
      </video>
      <img class="mobile" src="../assets/rank-header.svg" />
    </header>
    <img class="title" src="../assets/rank-title.svg" />
    <nav>
      <router-link to="/rank/examination">升國中</router-link>
      <router-link to="/rank/special-class">升高中</router-link>
      <router-link to="/rank/university">升大學</router-link>
    </nav>
    <Divider class="divider" />
    <section class="content">
      <PulseLoader
        class="loading"
        :loading="state == 'loading'"
        color="#f1d85b"
        size="20px"
      />
      <ErrorView v-if="state == 'error'" />
      <div v-if="state == 'display'">
        <ExpandableSection
          class="group"
          v-for="group in ranks"
          :key="group.year"
          :title="`${group.year}年`"
        >
          <dl>
            <Fragment v-for="rank in group.ranks" :key="rank.id">
              <dt>{{ rank.title }}</dt>
              <dd>
                <span
                  class="name"
                  v-for="name in rank.names"
                  :key="`${rank.id}-${name}`"
                >
                  {{ name }}
                </span>
              </dd>
            </Fragment>
          </dl>
        </ExpandableSection>
      </div>
    </section>
  </div>
</template>

<script>
import { Fragment } from "vue-fragment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import Divider from "@/components/Divider.vue";
import ExpandableSection from "@/components/ExpandableSection.vue";
import ErrorView from "@/components/ErrorView.vue";
import { withApiClient } from "@/api/ApiClient.js";

const Rank = {
  components: {
    Divider,
    ExpandableSection,
    ErrorView,
    Fragment,
    PulseLoader
  },
  data() {
    return {
      state: "idle",
      ranks: []
    };
  },
  mounted() {
    this.fetchRanks();
    if (this.$mq == "desktop") {
      this.$refs.video.setAttribute("autoplay", true);
    }
  },
  watch: {
    $route() {
      this.fetchRanks();
    }
  },
  methods: {
    fetchRanks() {
      this.state = "loading";
      this.apiClient
        .fetchRanks(this.$router.currentRoute.params.type)
        .subscribe(
          resp => {
            this.ranks = Object.values(
              resp.list.reduce((acc, it) => {
                acc[it.year] = acc[it.year] || [];
                acc[it.year].push(it);
                return acc;
              }, {})
            )
              .map(it => {
                return {
                  year: it[0].year,
                  ranks: it
                };
              })
              .sort((a, b) => (a.year < b.year ? 1 : -1));

            this.state = "display";
          },
          () => {
            this.state = "error";
          }
        );
    }
  }
};

export default withApiClient(Rank);
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 100px;

  .video {
    max-width: 1200px;
    width: 100%;
  }

  .title {
    margin: 70px auto;
    display: block;
    width: 135px;
  }

  nav {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    a {
      margin: 0 24px;
      background-color: #f3f3f4;
      border-radius: 14px;
      text-decoration: none;
      color: #6b6b6b;
      font-size: 16px;
      font-weight: bold;
      padding: 10px;

      &.router-link-active,
      &:hover {
        background-color: #c4cb7a;
        color: white;
      }
    }
  }

  .divider {
    width: 95%;
    max-width: 920px;
    margin: auto;
  }

  .content {
    width: 90%;
    max-width: 900px;
    margin: 40px auto;
  }

  .loading {
    text-align: center;
  }

  .group {
    margin: 15px;
  }

  dl {
    padding-bottom: 10px;
    border-bottom: 1px solid #e4e4e4;
  }

  dt {
    font-size: 18px;
    font-weight: bold;
    color: #595959;
    display: flex;
    flex-direction: row;

    &:before {
      content: "";
      display: block;
      background: url("../assets/joined-school-list-blue.svg") center center
        no-repeat;
      width: 15px;
      margin-right: 3px;
    }

    &:nth-child(4n - 1):before {
      background: url("../assets/joined-school-list-yellow.svg") center center
        no-repeat;
    }
  }

  dd {
    font-size: 16px;
    color: #595959;
    font-weight: 500;
    line-height: 1.5rem;
    margin-left: 1.1rem;
    margin-top: 3px;
  }

  .name {
    margin-right: 5px;
  }
}

@media (max-width: 480px) {
  nav {
    a {
      margin: 0 10px !important;
      padding: 9px 20px !important;
      font-size: 12px !important;
    }
  }
}

@media (max-width: 1023px) {
  header img {
    width: 100%;
  }

  .title {
    margin: 20px auto !important;
  }

  .divider {
    margin: auto 10px !important;
  }
}
</style>
